import * as React from 'react';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Card } from 'material-ui';
import { withNotifications } from '@components/hoc/withNotifications';
import { TicketsGenerateFormBasic } from '@modules/tickets/TicketsGenerateFormBasic';
import { generateTickets } from '@modules/tickets/_ticketsActions';

export const enhance = compose<any, any>(
  withNotifications({ generateTickets }),
  withHandlers({
    onSubmit: ({ closeItem, refresh, handleLoader, generateTicketsNotify }) => async data => {
      handleLoader(true);
      const result = await generateTicketsNotify(data);
      if (result) {
        if (refresh) {
          refresh();
        }
        await closeItem();
      }
      handleLoader(false);
    }
  }),
  breadcrumbs(() => [{ label: 'Generování' }]),
  reduxForm({ form: 'tickets-generate' })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <TicketsGenerateFormBasic />
        <Button type="submit" label="Generovat" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);
export const TicketsGenerateForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsGenerateForm.tsx